import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-loading',
  templateUrl: './common-loading.component.html',
  styleUrls: ['./common-loading.component.scss']
})
export class CommonLoadingComponent implements OnInit {
    @Input() isLoading = false;
    @Input() isPartial? = false;
    backgroundColor = 'rgba(#00000061, 0.38)';
    constructor() {}

    ngOnInit(): void {
      this.backgroundColor = this.isPartial
        ? '#FFFFFF61'
        : ' rgba(#00000061, 0.38)';
    }
}
